import React from "react";
import "./Navbar.css";
import { Toggle } from "../Toggle/Toggle";
import { Contact } from "../Contact/Contact";
import { Link } from "react-scroll";

export const Navbar = () => {
  return (
    <div className="n-wrapper" id="Navbar">
      <div className="n-left">
        <div className="n-name">Juan López</div>
        <Toggle />
      </div>
      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: "none" }}>
            <Link
              spy={true}
              to="Navbar"
              smooth={true}
              activeClass="activeClass"
            >
              <li>Home</li>
            </Link>
            <Link
              spy={true}
              to="Services"
              smooth={true}
              activeClass="activeClass"
            >
              <li>Services</li>
            </Link>
            <Link
              spy={true}
              to="Experience"
              smooth={true}
              activeClass="activeClass"
            >
              <li>Experience</li>
            </Link>
            <Link spy={true} to="Works" smooth={true} activeClass="activeClass">
              <li>Works</li>
            </Link>
          </ul>
        </div>
        <a
          href="https://www.instagram.com/jclopezvelez" target="blanck"
          style={{ textDecoration: "none", maxWidth: "3rem" }}
          className="button n-button"
        >
          Contact
        </a>
      </div>
    </div>
  );
};
